module.exports = __webpack_public_path__ + "media/images/metronic/social/youtube-e2388f4a5d0495c29a027c8efd160158.png";